import * as types from '../constants/ActionTypes';

const initialState = {
  params: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_QUERY_PARAMS:
      return Object.assign({}, state, { params: action.payload });
    default:
      return state;
  }
}
